"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GTMEvents {
}
GTMEvents.dependencies = [];
GTMEvents.processing = false;
GTMEvents.queue = [];
GTMEvents.successful = [];
// Check if the script(s) have been loaded and if all dependencies are true
GTMEvents.checkDependencies = () => GTMEvents.dependencies.every((dependency) => dependency());
// Check if we not done loading all scripts and dependencies
// OR if we have already have a queue?
GTMEvents.shouldBeQueued = () => !GTMEvents.checkDependencies() || GTMEvents.queue.length > 0;
GTMEvents.processEvent = (event) => {
    if (!event.track()) {
        // Only for debugging
        GTMEvents.successful.push(event);
    }
};
GTMEvents.addDependency = (dependency) => {
    GTMEvents.dependencies.push(dependency);
};
GTMEvents.processQueue = () => {
    if (GTMEvents.processing || !GTMEvents.checkDependencies()) {
        return false;
    }
    GTMEvents.processing = true;
    while (GTMEvents.queue.length) {
        const event = GTMEvents.queue.shift();
        GTMEvents.processEvent(event);
    }
    GTMEvents.processing = false;
    return true;
};
GTMEvents.addEvent = (event) => {
    if (GTMEvents.shouldBeQueued()) {
        GTMEvents.queue.push(event);
    }
    else {
        GTMEvents.processEvent(event);
    }
};
GTMEvents.debug = () => {
    return {
        processing: GTMEvents.processing,
        dependencies: GTMEvents.dependencies,
        dependencyCheck: GTMEvents.checkDependencies(),
        queue: GTMEvents.queue,
        successful: GTMEvents.successful,
    };
};
exports.default = GTMEvents;
//# sourceMappingURL=data:application/json;base64,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